/* Saucy Seltzer theme — interactions */
(function () {
  'use strict';
  /* pause animations that are off screen */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('sc-paused', !e.isIntersecting); });
    }, { rootMargin: '100px 0px' });
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section, .sc-band'), function (el) {
      if (el.querySelector('.sc-bob, .sc-bubble, .sc-track') || el.classList.contains('sc-band')) io.observe(el);
    });
  }
  var $ = function (s, r) { return (r || document).querySelector(s); };
  /* once the page has loaded, fetch the rest of the images in the background so
     sections further down are ready before you scroll to them */
  function warmImages() {
    Array.prototype.forEach.call(document.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
  }
  if (document.readyState === 'complete') setTimeout(warmImages, 200);
  else window.addEventListener('load', function () { setTimeout(warmImages, 200); });
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* age gate */
  var gate = $('[data-age-gate]');
  if (gate) {
    var ok = false;
    try { ok = localStorage.getItem('saucy_age_ok') === '1'; } catch (e) {}
    if (document.cookie.indexOf('saucy_age_ok=1') > -1) ok = true;
    if (!ok) { gate.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    var yes = $('[data-age-yes]', gate), no = $('[data-age-no]', gate);
    if (yes) yes.addEventListener('click', function () {
      try { localStorage.setItem('saucy_age_ok', '1'); } catch (e) {}
      document.cookie = 'saucy_age_ok=1; path=/; max-age=' + 60 * 60 * 24 * 30;
      gate.hidden = true; document.documentElement.style.overflow = '';
    });
    if (no) no.addEventListener('click', function () { window.location.href = gate.dataset.exitUrl || 'https://www.google.com'; });
  }

  /* shop dropdown */
  $$('[data-menu-toggle]').forEach(function (btn) {
    var menu = document.getElementById(btn.getAttribute('aria-controls'));
    if (!menu) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      menu.hidden = open;
    });
  });

  /* toggle groups: aria-pressed buttons that set a value on a container */
  function group(container, attr, onChange) {
    var btns = $$('button[' + attr + ']', container);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        onChange(b.getAttribute(attr), b);
      });
    });
  }

  /* product gallery */
  $$('[data-gallery]').forEach(function (g) {
    var stage = $('[data-stage]', g), img = $('[data-stage-img]', g), label = $('[data-stage-label]', g);
    group(g, 'data-thumb', function (_, b) {
      img.src = b.dataset.src; img.alt = b.dataset.alt || '';
      var photo = b.dataset.photo === 'true';
      img.classList.toggle('is-photo', photo); stage.classList.toggle('is-photo', photo);
      if (label) label.textContent = b.dataset.label || '';
    });
  });

  /* quantity steppers */
  $$('[data-qty]').forEach(function (q) {
    var input = $('input', q);
    $$('[data-step]', q).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10));
        input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* product form: pack option + quantity -> total on button */
  $$('[data-product-form]').forEach(function (f) {
    var btnTotal = $('[data-total]', f), qty = $('[name="sc_qty"]', f), price = parseInt(f.dataset.price, 10) || 0;
    var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
    function update() {
      var opt = $('[name="sc_pack"]:checked', f), mult = opt ? parseInt(opt.value, 10) : 1;
      var n = (parseInt(qty.value, 10) || 1) * mult;
      f.querySelector('[data-real-qty]').value = n;
      if (btnTotal) btnTotal.textContent = money(price * n);
    }
    f.addEventListener('change', update); update();
  });

  /* vibe finder */
  $$('[data-finder]').forEach(function (f) {
    group(f, 'data-mood', function (key) {
      $$('[data-pick]', f).forEach(function (p) { p.classList.toggle('is-active', p.dataset.pick === key); });
    });
  });

  /* catalog filters */
  $$('[data-catalog]').forEach(function (c) {
    var state = { effect: 'all', thc: 'any', sort: 'featured' };
    var grid = $('[data-grid]', c), count = $('[data-count]', c), empty = $('[data-empty]', c);
    function apply() {
      var cards = $$('[data-card]', grid), shown = 0;
      cards.forEach(function (card) {
        var okE = state.effect === 'all' || card.dataset.effect === state.effect;
        var thc = (card.dataset.thc || '').split(',');
        var okT = state.thc === 'any' || thc.indexOf(state.thc) > -1;
        card.classList.toggle('sc-hidden', !(okE && okT));
        if (okE && okT) shown++;
      });
      cards.sort(function (a, b) {
        if (state.sort === 'low') return a.dataset.price - b.dataset.price;
        if (state.sort === 'high') return b.dataset.price - a.dataset.price;
        return a.dataset.order - b.dataset.order;
      }).forEach(function (card) { grid.appendChild(card); });
      if (count) count.textContent = shown;
      if (empty) empty.classList.toggle('sc-hidden', shown > 0);
    }
    ['effect', 'thc', 'sort'].forEach(function (k) {
      group(c, 'data-' + k, function (v) { state[k] = v; apply(); });
    });
    var reset = $('[data-reset]', c);
    if (reset) reset.addEventListener('click', function () {
      state.effect = 'all'; state.thc = 'any';
      $$('[data-effect],[data-thc]', c).forEach(function (b) { if (b.tagName === 'BUTTON') b.setAttribute('aria-pressed', (b.dataset.effect === 'all' || b.dataset.thc === 'any') ? 'true' : 'false'); });
      apply();
    });
  });

  /* searchable lists (FAQ, COA batches) */
  $$('[data-search]').forEach(function (input) {
    var scope = document.getElementById(input.dataset.search);
    if (!scope) return;
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      $$('[data-search-item]', scope).forEach(function (item) {
        var hit = !q || item.textContent.toLowerCase().indexOf(q) > -1;
        item.classList.toggle('sc-hidden', !hit);
        if (hit && q.length > 1 && item.tagName === 'DETAILS') item.open = true;
      });
      $$('[data-search-group]', scope).forEach(function (g) {
        g.classList.toggle('sc-hidden', !$$('[data-search-item]:not(.sc-hidden)', g).length);
      });
      var empty = $('[data-search-empty]', scope);
      if (empty) empty.classList.toggle('sc-hidden', !q || $$('[data-search-item]:not(.sc-hidden)', scope).length > 0);
    });
  });

  /* tab filters (FAQ topics, COA products) */
  $$('[data-tabs]').forEach(function (t) {
    var scope = document.getElementById(t.dataset.tabs);
    group(t, 'data-tab', function (key) {
      $$('[data-tab-panel]', scope).forEach(function (p) {
        p.classList.toggle('sc-hidden', key !== 'all' && p.dataset.tabPanel !== key);
      });
    });
  });

  /* contact-style topic chips -> hidden field */
  $$('[data-chips]').forEach(function (c) {
    var field = document.getElementById(c.dataset.chips);
    group(c, 'data-chip', function (v) { if (field) field.value = v; });
  });

  /* cart */
  $$('[data-cart]').forEach(function (root) {
    var form = $('form', root);
    $$('[data-qty] input', root).forEach(function (input) {
      input.addEventListener('change', function () {
        $$('[data-gate]', root).forEach(function (g) { g.required = false; });
        form.submit();
      });
    });
    var gates = $$('[data-gate]', root), checkout = $('[data-checkout]', root), msg = $('[data-gate-msg]', root);
    function refresh() {
      var ok = gates.every(function (g) { return g.checked; });
      if (checkout) checkout.disabled = !ok;
      if (msg) msg.hidden = ok;
    }
    gates.forEach(function (g) { g.addEventListener('change', refresh); }); refresh();
    var apply = $('[data-apply-code]', root);
    if (apply) apply.addEventListener('click', function () {
      var code = $('[data-code]', root).value.trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root.dataset.cartUrl || '/cart');
    });
    $$('[data-add-variant]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.addVariant, 10), quantity: 1 }] })
        }).then(function () { window.location.reload(); });
      });
    });
  });

  /* side by side (phones): show the two picked products */
  $$('[data-cmp2]').forEach(function (root) {
    var sels = $$('[data-cmp-side]', root);
    function apply(changed) {
      var a = sels[0].value, b = sels[1].value;
      if (a === b) {
        var other = changed === sels[0] ? sels[1] : sels[0];
        other.value = String((parseInt(changed.value, 10) + 1) % other.options.length);
        a = sels[0].value; b = sels[1].value;
      }
      $$('[data-p]', root).forEach(function (el) {
        var p = el.getAttribute('data-p');
        el.hidden = p !== a && p !== b;
        el.style.order = p === a ? 0 : 1;
      });
    }
    sels.forEach(function (s) { s.addEventListener('change', function () { apply(s); }); });
  });
})();
